module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_2.c6b23f68.png";